/* PlansViewPricingLink.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import Button from '@atlaskit/button/standard-button';
import InviteTeamIcon from '@atlaskit/icon/glyph/invite-team';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTransition } from '@atlaskit/modal-dialog';
import { media } from '@atlaskit/primitives';
import { BodyNormal, H4, LinkButton, useScrollLock } from '@atlassian/mpac-primitives';
import { useState } from 'react';
import { PlansTieredPricingModalTable } from './PlansTieredPricingModalTable';
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const _26 = "@media not all and (min-width:48rem){._4uroidpf{margin-left:0}}";
const _25 = "._1iohnqa1:active, ._jf4cnqa1:hover{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _24 = "._c2waglyw:active, ._1bnxglyw:hover{-webkit-text-decoration-line:none;text-decoration-line:none}";
const _23 = "._1nrm18uv:active, ._9oik18uv:hover{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _22 = "._xb55idpf:active, ._1bcridpf:hover{padding-left:0}";
const _21 = "._o3qsidpf:active, ._f3ydidpf:hover{padding-bottom:0}";
const _20 = "._1d2aidpf:active, ._1qn1idpf:hover{padding-right:0}";
const _19 = "._mnzyidpf:active, ._17rqidpf:hover{padding-top:0}";
const _18 = "._18u0u2gc{margin-left:var(--ds-space-100,8px)}";
const _17 = "._19bvidpf{padding-left:0}";
const _16 = "._n3tdidpf{padding-bottom:0}";
const _15 = "._u5f3idpf{padding-right:0}";
const _14 = "._ca0qidpf{padding-top:0}";
const _13 = "._18u0idpf{margin-left:0}";
const _12 = "._otyridpf{margin-bottom:0}";
const _11 = "._2hwxidpf{margin-right:0}";
const _10 = "._19pkidpf{margin-top:0}";
const _9 = "@media not all and (min-width:64rem){._o5kc1h6o{justify-content:center}}";
const _8 = "@media not all and (min-width:48rem){._8164pxbi{gap:var(--ds-space-200,1pc)}._1gde1bp4{flex-direction:column}}";
const _7 = "._1wpz1fhb{align-self:stretch}";
const _6 = "._4cvr1h6o{align-items:center}";
const _5 = "._1e0c1txw{display:flex}";
const _4 = "._2rkou2gc{border-radius:var(--ds-space-100,8px)}";
const _3 = "._11q711bn{background:var(--ds-background-accent-gray-subtlest,#f1f2f4)}";
const _2 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _ = "._1yt4t9rj{padding:var(--_186zcqb)}";
const viewPricingFooterSection = null;
const viewPricingLabel = null;
const viewPricingFooterButton = null;
const noMargin = null;
export const PlansViewPricingLink = _ref => {
  let {
    editions,
    billingFrequency
  } = _ref;
  const [isModalOpen, setIsModalOpen] = useState(false);

  // For layout shift when modal opens
  useScrollLock(isModalOpen);
  const closeViewPricingModal = () => setIsModalOpen(false);
  const handleViewPricingClick = e => {
    e.preventDefault();
    setIsModalOpen(true);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ModalTransition, {
      children: isModalOpen && /*#__PURE__*/_jsxs(Modal, {
        onClose: closeViewPricingModal,
        width: "medium",
        testId: "plans-pricing-tier-modal",
        children: [/*#__PURE__*/_jsx(ModalHeader, {
          children: /*#__PURE__*/_jsxs(H4, {
            as: "div",
            children: ["Cloud app pricing |", ' ', billingFrequency === 'monthlyPricingPlan' ? 'Monthly per user' : 'Annual price']
          })
        }), /*#__PURE__*/_jsx(ModalBody, {
          children: /*#__PURE__*/_jsx(PlansTieredPricingModalTable, {
            billingFrequency: billingFrequency,
            editions: editions
          })
        }), /*#__PURE__*/_jsx(ModalFooter, {
          children: /*#__PURE__*/_jsx(Button, {
            appearance: "primary",
            onClick: closeViewPricingModal,
            children: "Close"
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2, _3, _4, _5, _6, _7, _8, _9]
      }), /*#__PURE__*/_jsxs("div", {
        className: ax(["_1yt4t9rj _zulpu2gc _11q711bn _2rkou2gc _1e0c1txw _4cvr1h6o _1wpz1fhb _8164pxbi _1gde1bp4 _o5kc1h6o"]),
        style: {
          "--_186zcqb": ix("var(--ds-space-200, 16px)".concat(" ", "var(--ds-space-300, 24px)"))
        },
        children: [/*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_2, _5, _6]
          }), /*#__PURE__*/_jsxs("div", {
            className: ax(["_zulpu2gc _1e0c1txw _4cvr1h6o"]),
            children: [/*#__PURE__*/_jsx(InviteTeamIcon, {
              label: "Invite team icon",
              primaryColor: "var(--ds-icon, #44546F)"
            }), /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_10, _11, _12, _13]
              }), /*#__PURE__*/_jsx(BodyNormal, {
                className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf"]),
                children: "Planning for team growth?"
              })]
            })]
          })]
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26]
          }), /*#__PURE__*/_jsx(LinkButton, {
            appearance: "link",
            onClick: handleViewPricingClick,
            "aria-label": "Explore pricing for different user tiers",
            className: ax(["_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _18u0u2gc _mnzyidpf _17rqidpf _1d2aidpf _1qn1idpf _o3qsidpf _f3ydidpf _xb55idpf _1bcridpf _1nrm18uv _9oik18uv _c2waglyw _1bnxglyw _1iohnqa1 _jf4cnqa1 _4uroidpf"]),
            children: "View pricing for different user tiers"
          })]
        })]
      })]
    })]
  });
};